/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssetDomain { 
    agency: string;
    client: string;
    brand: string;
    category?: string;
    product?: string;
    subcategory?: string;
    brandMarke?: string;
    brandModel?: string;
}

